import axiosInstance from '../../../services/axios/axios';
import { WrapImsPacket } from '../../../store/utility';

/**
 * Submit a Citrix Exception
 *
 */
export const SubmitCitrixException = async ExceptionArgs => {
	try {
		const response = await axiosInstance.post(
			`api/CitrixException/Submission`,
			WrapImsPacket(ExceptionArgs)
		);

		return response;
	} catch (ex) {
		console.error('Unable to submit exception: ' + ex);
		return {
			data: [],
			error: 'An Error Occurred Fetching data from the server',
		};
	}
};

/**
 * Search for Person
 *
 */
export const fetchPersonSearch = async payload => {
	try {
		const response = await axiosInstance.post(
			`api/Components/PersonSearch`,
			payload
		);
		return response;
	} catch (ex) {
		console.error('Unable to fetch person search: ' + ex);
		return {
			data: [],
			error: 'An Error Occurred Fetching data from the server',
		};
	}
};
